// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"665":"82e16c60","667":"1ace2666"}[chunkId] + ".chunk.js";
};